import { FiMenuItemSearchComponent } from './fi-menu-item-search.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { CdkFixedSizeVirtualScroll, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';

@NgModule({
    declarations: [FiMenuItemSearchComponent],
    exports: [FiMenuItemSearchComponent],
    imports: [
        BrowserModule,
        FormsModule,
        CommonModule,
        FiAppTextSharedModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatRadioModule,
        MatDividerModule,
        MatIconModule,
        CdkFixedSizeVirtualScroll,
        CdkVirtualScrollViewport,
        FiWhenScrolledModule,
    ],
})
export class FiMenuItemSearchModule {}
